/**
 * X-axis domain for the Focus overlay charts.
 *
 * The chart data is keyed by `t` = seconds-from-window-start. Using the case's
 * nominal window (`[0, totalS]`, i.e. min(started_at)→max(ended_at)) leaves
 * dead space whenever a recording's `ended_at` runs past its last real data
 * point (it stopped producing samples early, or the sensor dropped) — which
 * squashes the traces into a fraction of the axis. Instead, derive the domain
 * from the actual data extent across BOTH the focus and motion series (so the
 * two charts stay aligned on one wall-clock axis), with a small pad so the
 * ends don't sit flush against the frame. Falls back to the full window when
 * there's no data.
 */
export function focusXDomain(
  chartData: { t: number }[],
  motionData: { t: number }[],
  totalS: number,
): [number, number] {
  const ends: number[] = [];
  if (chartData.length)
    ends.push(chartData[0].t, chartData[chartData.length - 1].t);
  if (motionData.length)
    ends.push(motionData[0].t, motionData[motionData.length - 1].t);
  if (ends.length === 0) return [0, totalS];
  const lo = Math.min(...ends);
  const hi = Math.max(...ends);
  const pad = Math.max(1, Math.round((hi - lo) * 0.02));
  return [Math.max(0, lo - pad), hi + pad];
}
